import React from "react";
import {convertDateToRelativeTime} from "../utils/Utils";


export function DMSDateColumnFormatter(cellContent, row) {
    return (
        <span>{convertDateToRelativeTime(cellContent)}</span>
    );
}
